'use strict';

// Import Module
import './modules/hamburger';
import './modules/frontAnime';
import './modules/utility';
import './modules/smoothScroll';

// Sass Import
import '../Sass/style.scss';
